//Initialize Accordion
if (document.querySelector(".accordion-container")) {
	new Accordion(".accordion-container");
}

//Carousel Script
if (document.querySelector(".glide__slides")) {
    var allSlides = document.querySelectorAll(".glide");

    allSlides.forEach((slide) => {

        // Calculate the total number of slides
        let totalSlides = slide.querySelectorAll('.glide__slide').length;
        let formattedTotalSlides = String(totalSlides).padStart(2, '0'); // Ensure it's two digits

        const glide = new Glide(slide, {
            type: "carousel",
            perView: 1.5, // Show 1 full slide and half of the next one
            perTouch: 1,
            focusAt: 'center', // Focus at the center
            startAt: 0,
            rewind: false,
            accessibility: true,
            classes: {
                disabledArrow: "glide__arrow--disabled",
            }
        }).mount();

        // Initialize the slide counter
        let slider_counter = document.querySelector('.slide-counter');
        if (slider_counter) {
            slider_counter.textContent = '01/' + formattedTotalSlides;
        }

        // Preserve the margin-left on the first slide
        let firstSlide = slide.querySelector('.glide__slide:first-child');
        if (firstSlide) {
            firstSlide.style.marginLeft = '120px';
        }

        // Add an event listener for the 'run.after' event
        glide.on('run.after', function () {
            // Get the current slide index (zero-based)
            var currentIndex = glide.index;

            // Update the slide counter
            if (slider_counter) {
                let itemcounter = (currentIndex + 1);
                let resultitemcounter = String(itemcounter).padStart(2, '0');
                slider_counter.textContent = resultitemcounter + '/' + formattedTotalSlides;
            }
        });
    });
}





//Check if Header Button link is external
const btns = document.querySelectorAll(".wp-block-button__link");
const allBtns = Array.prototype.slice.call(btns);
const currentHost = window.location.hostname;

let externalText = document.createElement("span");
externalText.append(document.createTextNode("link will open external site"));
externalText.classList.add("screen-reader-text");

if (btns) {
	allBtns.forEach((btn) => {
		if (btn.hasAttribute("href")) {
			let ctaLink = btn.getAttribute("href").split("/");

			if (ctaLink[2] !== currentHost) {
				btn.classList.add("external-link");
				btn.append(externalText);
			}
		}
	});
}
if (document.querySelector(".cta-btn")) {
	let currentHost = window.location.hostname;
	let ctaBtn = document.querySelector(".cta-btn");
	let ctaLink = ctaBtn.getAttribute("href").split("/");

	if (ctaLink[0] !== currentHost) {
		ctaBtn.classList.add("external-link");
		ctaBtn.append(externalText);
	}
}


////Pagination
if (document.querySelector(".navigation-pagination")) {
	let paginationList = document.querySelectorAll(".navigation-pagination ul li");

	if (paginationList[0].classList.contains("active")) {
		paginationList[0].style.position = "relative";
	}

	if (paginationList[paginationList.length - 1].classList.contains("active")) {
		paginationList[paginationList.length - 1].style.position = "relative";
	}
}

////Masonary
if (document.querySelector(".allcontainer")) {
	var elem = document.querySelector(".allcontainer");
	var msnry = new Masonry(elem, {
		// options
		itemSelector: ".item",
		columnWidth: ".grid-sizer",
		gutter: 15,
	});

	//Filters
	// const filterBtn = document.querySelectorAll('.filters button');
	// var allfilterBtn = Array.prototype.slice.call(filterBtn);
	//let allblocks = document.querySelectorAll('.item');
	let allblocks = Array.prototype.slice.call(document.querySelectorAll(".item"));
	let selectedValue;
	let selectedOption;
	let availableItems;
	let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

	for (let i = 0; i < buttons.length; i++) {
		buttons[i].addEventListener("click", onClickChange);
	}

	//Click Filter
	function onClickChange() {
		selectedValue = this.value;
		// if(selectedValue !== 'all'){
		//   allblocks = document.querySelectorAll('.item.block');
		// }
		allblocks.forEach(function (block) {
			block.classList.remove("block");

			if (selectedValue == "all") {
				block.classList.add("block");
			}

			if (block.getAttribute("data-cat") == selectedValue) {
				block.classList.add("block");
			}
		});
		msnry.layout();

		availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));
		document.getElementById("select").addEventListener("change", onSelectChange);
	}

	availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));

	document.getElementById("select").addEventListener("change", onSelectChange);

	function onSelectChange() {
		selectedOption = this.value;

		availableItems.forEach(function (item) {
			item.classList.remove("block");

			if (selectedOption == "all") {
				item.classList.add("block");
			}

			if (item.getAttribute("data-tag") == selectedOption) {
				item.classList.add("block");
			}
		});

		//Filter Click
		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener("click", onClickChange);
		}

		msnry.layout();
	}

	/////Script_AJAX
	/* Ajax functions */
	$(document).ready(function () {
		//onclick
		$("#loadMore").on("click", function (e) {
			e.preventDefault();
			//init
			var that = $(this);
			var page = $(this).data("page");
			var newPage = page + 1;
			var ajaxurl = that.data("url");
			//ajax call
			$.ajax({
				url: ajaxurl,
				type: "post",
				data: {
					page: page,
					action: "ajax_script_load_more",
				},
				error: function (response) {
					console.log(response);
				},
				success: function (response) {
					//check
					if (response == 0) {
						$(".allcontainer").append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
						$("#loadMore").hide();
					} else {
						that.data("page", newPage);
						$("#ajax-primary").append(response);

						msnry = new Masonry(elem, {
							// options
							itemSelector: ".item",
							columnWidth: ".grid-sizer",
							gutter: 15,
						});

						msnry.layout();
					}
				},
			});
		});
	});
}

//Breadcrumb Spacing
if (document.querySelector(".breadcrumb-container")) {
	document.querySelector(".content-area").style.marginTop = 0;
}

//Button Custom Colors Hover
var customBtn = $(".wp-block-button a.has-text-color.has-background");

customBtn.each(function (index) {
	var btnbgColor = $(this).css("backgroundColor");
	var btnColor = $(this).css("color");

	$(this)
		.mouseenter(function () {
			$(this).css({
				"background-color": btnColor,
				color: btnbgColor,
				"border-color": btnColor
			});
		})
		.mouseleave(function () {
			$(this).css({
				"background-color": btnbgColor,
				color: btnColor,
				"border-color": btnbgColor
			});
		});
});

// hero video scroll to next section js
// $('#scroll-down-animation').each(function() {
//     $(this).on('click', function () {
//         var nextSection = $(this).parent().next();
//         //animate to the next section, edit the offset and time
//         $('html, body').animate({
//             scrollTop: nextSection.offset().top + 1
//         }, 1000 );
//     });
// });

// hero video play pause video code

(function(){
    // Select all elements with the class "play-hero-video"
    let playherovideobutton = document.querySelectorAll(".play-hero-video");

    // If there are no elements with the class "play-hero-video", exit the function
    if(!playherovideobutton){
        return false;
    }

    // Loop over each element with the class "play-hero-video"
    for(let i =0; i <playherovideobutton.length; i++){
        // Select the iframe that is a child of the parent of the current "play-hero-video" element
        let iframe = playherovideobutton[i].parentNode.querySelector('iframe');

        // Define a function to toggle the video state
        let toggleVideoState = function(e){
            // Toggle the "playing" and "paused" classes on the current target of the event
            e.currentTarget.classList.toggle("playing");
            e.currentTarget.classList.toggle("paused");

            // If the iframe exists
            if(iframe){
                // If the current target of the event has the class "playing"
                if (e.currentTarget.classList.contains("playing")) {
                    // Send a postMessage to the iframe to play the video
                    iframe.contentWindow.postMessage(JSON.stringify({method: "play"}), "*");
                } else {
                    // Send a postMessage to the iframe to pause the video
                    iframe.contentWindow.postMessage(JSON.stringify({method: "pause"}), "*");
                }
            }
        }

        // Add a click event listener to the current "play-hero-video" element
        playherovideobutton[i].addEventListener("click", toggleVideoState);

        // Add a keydown event listener to the current "play-hero-video" element
        playherovideobutton[i].addEventListener("keydown", function(e) {
            // If the key pressed was Enter
            if (e.key === 'Enter' || e.keyCode === 13) {
                // Call the toggleVideoState function
                toggleVideoState(e);
            }
        });
    }
})();

// code to fix accordion not working on icons clicks
function accordionIconsClick(){
    // Select all elements with the class "acc-open-icon" or "acc-close-icon"
    let accopenicon = document.querySelectorAll(".acc-open-icon,.acc-close-icon");

    // If there are no elements with the class "acc-open-icon" or "acc-close-icon", exit the function
    if(!accopenicon){
        return false;
    }

    // Loop over each element with the class "acc-open-icon" or "acc-close-icon"
    for(let i = 0; i < accopenicon.length; i++){
        // Get the current item in the loop
        let item = accopenicon[i];

        // Add a click event listener to the current item
        item.addEventListener("click",function(e){
            // When the item is clicked, trigger a click event on its parent element
            e.currentTarget.parentNode.click();
        })
    }
}
accordionIconsClick();


// Code for linking location submenu to tab component
document.addEventListener("DOMContentLoaded",function(c){
    // console.log("Dom loaded");
    let idToClick = (window.location.hash).split("?")[0];
    // console.log("ID extracted "+idToClick);
    if(!idToClick){
        return false;
    }
    let allItemsToClick = document.querySelectorAll(idToClick);
    if(!allItemsToClick){
        return false;
    }
    console.log("ID element selected ", allItemsToClick);
    for(let i =0; i <allItemsToClick.length;i++){
        // console.log(allItemsToClick[i], "clicked");
        setTimeout(() => {
            allItemsToClick[i].click();
        }, 100);
    }
})